<template>
    <project  ref="project"
        classContainer="brink-container brink-2" 
        classOverlay="overlay-brink"
        :ghostVideo="this.ghostVideo"
        :bubbleOneData="this.bubbleOneData"
        :videoOneData="this.videoOneData"
        :previewOneData="this.previewOneData"/>

    <!--<img class="example" src="@/assets/brink/home2.jpg" />-->
</template>

<script>
    import Project from '../../Project.vue'

    export default {
        components: { Project}, 
        name: "brinkTwo",
        data: () => ({
            ghostVideo: false,
            bubbleOneData: {
                class: 'bubble-one-brink-2',
                text: "<p> There was a vas range of data to<br/> visualize: different weapons and<br/>"+
                            "where each hits targets, performance<br/> on different sides, the list goes on. </p><br/>"+
                            "<p>We needed to create ways of<br/> visualizing data that were as beautiful<br/>"+
                            "and fun as they were immediate and<br/> engaging.</p>",
                title: "Data Viz", fontSizeInnerText:"0.85rem", marginLeft:"-2rem",
                marginTop:"2%", color:"#14677b", colorOverlay:"#fff", colorText:"#14677b"
            },
            videoOneData:{
                class: 'brink-2-video',
                videoUrl: 'assets/brink/home2-right.mp4',
                poster: 'assets/brink/brink2-cover.jpg',
                isUnitedCenter: false,
                onAxisY:false
            },
            previewOneData:{
                class: 'brink-2-preview',
                img:"assets/brink/brink_slide_2.jpg",
                isBrik: true,
                forward:false,
                upDown:true

            },
        }),
        methods: {
            openNonAnimated(){
                this.$refs.project.openNonAnimated()
            },
            open(onOpened){
                this.$refs.project.open(onOpened)
            },
            close(){
                this.$refs.project.close()
            },
            pause(){
                this.$refs.project.pause()
            },
            play(){
                this.$refs.project.play()
            },
            isHovering(){
                return this.$refs.project.isHovering
            }
        },
    }
</script>

<style>
    .brink-2-preview{
        width: 43vw;
        height: 28vw;
        top: 17%;
        left: 18%;
    }
    
    .brink-2-video{
        top: 27.5% !important;
        left: 63.5% !important;
        width: 20vw !important;
        height: 11vw !important;
    }

    .bubble-one-brink-2{
        left: 67.25%;
        top: 59.25%;
        height: 17.5vw;
        width: 17.5vw;
    }

    @media (orientation: portrait) {
        .bubble-one-brink-2 {
            left: 40.25%;
            height: 57vw;
            width: 57vw;
        }

        .brink-2-preview{
            width: 86vw;
            height: 56vw;
            top: 30%;
            left: 6%;
        }

        .brink-2-video{
            left: 59.5% !important;
            top: 36.5% !important;
            width: 39.5vw !important;
            height: 22vw !important;
        }
    }

</style>